import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RiToolsLine, RiArrowLeftLine } from 'react-icons/ri';
import { usePageState } from '../../context/ConfigContext';

/* Wraps a routed page. When an admin closes it, the route still exists and
   the nav link still works — the learner gets an explanation instead of a
   dead link or a blank screen. The API refuses too, so this is the polite
   face of a real block rather than the block itself. */
export default function PageGate({ pageKey, children }) {
  const navigate = useNavigate();
  const { enabled, message, label } = usePageState(pageKey);

  if (enabled) return children;

  return (
    <div className="page-container anim-fade-up">
      <div className="ks-card maint-card">
        <div className="maint-icon"><RiToolsLine size={26} /></div>
        <h1>{label || 'This page'} is under maintenance</h1>
        <p>{message || 'We are making some changes here. Everything else in the app is working normally — please check back shortly.'}</p>
        <button className="btn-primary" onClick={() => navigate('/dashboard')}>
          <RiArrowLeftLine size={15} /> Back to learning
        </button>
      </div>
    </div>
  );
}
